// pt-BR translations for the buyer payment portal. Generated to mirror
// en.ts keys 1:1; ICU placeholders ({seller}, {qty}, …) preserved verbatim.
// Brand names and financial acronyms (Caratuva, ACH, SEPA, IBAN,
// SWIFT, PIX, CNPJ, CPF, KYC, …) intentionally kept untranslated.
const ptBR: Record<string, string> = {
  'app.name': 'Caratuva',
  'locale.label': 'Idioma',
  'invoice.title': 'Fatura de {seller}',
  'invoice.amount.label': 'Valor a pagar',
  'invoice.lineItems.heading': 'Itens da fatura',
  'invoice.lineItem.qty': 'Qtd {qty} × {unitPrice}',
  'invoice.cta.signin': 'Entrar para pagar',
  'invoice.cta.continue': 'Continuar para pagar',
  'invoice.dueDate': 'Vencimento {date}',
  'invoice.status.label': 'Status',
  'invoice.error.notFound': 'Fatura não encontrada.',
  'signin.heading': 'Entrar para pagar',
  'signin.subheading': 'Enviaremos um link único por e-mail. Nenhuma senha é necessária.',
  'signin.email.label': 'Email',
  'signin.email.placeholder': 'você@empresa.com',
  'signin.submit': 'Enviar link de acesso',
  'signin.tos':
    'Ao continuar, você concorda com nossos <terms>Termos de Serviço</terms> e nossa <privacy>Política de Privacidade</privacy>.',
  'signin.success.heading': 'Verifique seu e-mail',
  'signin.success.body': 'Enviamos um link de acesso. Ele expira em 15 minutos.',
  'signin.error.emailMismatch': 'Esse e-mail não corresponde ao destinatário da fatura.',
  'signin.error.generic': 'Não foi possível enviar o link de acesso. Tente novamente em instantes.',
  'signin.session.expired': 'Sua sessão expirou. Faça login novamente.',
  'consume.loading': 'Entrando...',
  'consume.error.invalid': 'Este link de acesso é inválido.',
  'consume.error.used': 'Este link de acesso já foi utilizado. Solicite um novo.',
  'consume.error.expired': 'Este link de acesso expirou. Solicite um novo.',
  'consume.error.generic': 'Não foi possível fazer seu acesso. Solicite um novo link de acesso.',
  'consume.cta.requestNew': 'Solicitar um novo link',
  'kyc.heading': 'Verifique sua identidade',
  'kyc.subheading':
    'Conclua uma verificação de identidade única para que possamos liberar o on-ramp (entrada de fundos) desta fatura.',
  'kyc.step.entityType': 'Tipo de conta',
  'kyc.step.tos': 'Termos de serviço',
  'kyc.step.personal': 'Dados pessoais',
  'kyc.step.address': 'Endereço',
  'kyc.step.documents': 'Documentos de identidade',
  'kyc.step.business': 'Dados da empresa',
  'kyc.step.businessAddress': 'Endereço da empresa',
  'kyc.step.owners': 'Beneficiários finais',
  'kyc.step.businessDocuments': 'Documentos da empresa',
  'kyc.step.review': 'Revisão',
  'kyc.step.indicator': 'Etapa {current} de {total}',
  'kyc.entityType.heading': 'Você está preenchendo isto em nome próprio ou de uma empresa?',
  'kyc.entityType.body':
    'Escolha a opção que corresponde a quem está pagando. Empresas precisam fornecer documentos da empresa e informações dos beneficiários finais; pessoas físicas precisam apenas do documento de identidade pessoal.',
  'kyc.entityType.individual': 'Pessoa física',
  'kyc.entityType.individual.body':
    'Você está pagando como pessoa física, não em nome de uma empresa.',
  'kyc.entityType.business': 'Empresa',
  'kyc.entityType.business.body':
    'Você está pagando em nome de uma empresa registrada ou outra entidade jurídica.',
  'kyc.field.legalName.label': 'Razão social',
  'kyc.field.legalName.placeholder': 'Caratuva Inc.',
  'kyc.field.formationDate.label': 'Data de constituição',
  'kyc.field.website.label': 'Site da empresa',
  'kyc.field.website.placeholder': 'https://example.com',
  'kyc.field.businessTaxId.label': 'Identificação fiscal da empresa',
  'kyc.field.businessTaxId.placeholder': '12-3456789 / 12.345.678/0001-95',
  'kyc.field.businessTaxId.hint': 'EIN (US), CNPJ (BR) ou equivalente local.',
  'kyc.field.incorporationDocFile.label': 'Documento de constituição',
  'kyc.field.incorporationDocFile.hint':
    'Contrato social, certificado de constituição ou equivalente.',
  'kyc.field.proofOfOwnershipDocFile.label': 'Comprovante de titularidade',
  'kyc.field.proofOfOwnershipDocFile.hint':
    'Quadro societário, registro de titularidade ou equivalente que mostre os beneficiários finais listados.',
  'kyc.owners.heading': 'Beneficiários finais',
  'kyc.owners.body':
    'Adicione qualquer pessoa que detenha 25% ou mais da empresa ou que exerça controle significativo. Cada beneficiário precisa passar pela mesma verificação de identidade de um comprador pessoa física.',
  'kyc.owners.add': 'Adicionar outro beneficiário',
  'kyc.owners.remove': 'Remover',
  'kyc.owners.title': 'Beneficiário {index}',
  'kyc.owners.role.label': 'Função',
  'kyc.owners.role.placeholder': 'Selecione uma função',
  'kyc.owners.role.beneficial_controlling': 'Beneficiário final e pessoa controladora',
  'kyc.owners.role.beneficial_owner': 'Beneficiário final',
  'kyc.owners.role.controlling_person': 'Pessoa controladora',
  'kyc.owners.taxType.label': 'Tipo de identificação fiscal (apenas US)',
  'kyc.owners.taxType.placeholder': 'Selecione um tipo de identificação fiscal',
  'kyc.owners.taxType.SSN': 'SSN',
  'kyc.owners.taxType.ITIN': 'ITIN',
  'kyc.owners.proofOfAddress.label': 'Comprovante de endereço',
  'kyc.owners.proofOfAddress.hint':
    'Documento que comprove o endereço residencial do beneficiário final (emitido nos últimos 90 dias).',
  'kyc.owners.proofOfAddressType.label': 'Tipo de comprovante de endereço',
  'kyc.owners.proofOfAddressType.placeholder': 'Selecione um tipo de documento',
  'kyc.owners.proofOfAddressType.UTILITY_BILL': 'Conta de serviço público',
  'kyc.owners.proofOfAddressType.BANK_STATEMENT': 'Extrato bancário',
  'kyc.owners.proofOfAddressType.RENTAL_AGREEMENT': 'Contrato de aluguel',
  'kyc.owners.proofOfAddressType.TAX_DOCUMENT': 'Documento fiscal',
  'kyc.owners.proofOfAddressType.GOVERNMENT_CORRESPONDENCE': 'Correspondência de órgão público',
  'kyc.tos.heading': 'Aceite os termos de serviço do parceiro de liquidação',
  'kyc.tos.body':
    'Você será redirecionado para o nosso parceiro de liquidação para revisar e aceitar os termos de serviço. Após a aceitação, traremos você de volta para continuar.',
  'kyc.tos.cta': 'Continuar para os termos de serviço',
  'kyc.tos.cta.pending': 'Abrindo o parceiro de liquidação…',
  'kyc.tos.accepted': 'Termos de serviço aceitos.',
  'kyc.tos.required': 'Aceite os termos de serviço antes de continuar.',
  'kyc.tos.error':
    'Não foi possível iniciar o fluxo dos termos de serviço. Tente novamente em instantes.',
  'kyc.field.email.label': 'Email',
  'kyc.field.firstName.label': 'Nome',
  'kyc.field.firstName.placeholder': 'Maria',
  'kyc.field.lastName.label': 'Sobrenome',
  'kyc.field.lastName.placeholder': 'Silva',
  'kyc.field.dateOfBirth.label': 'Data de nascimento',
  'kyc.field.taxId.label': 'Identificação fiscal',
  'kyc.field.taxId.placeholder': '123-45-6789 / 123.456.789-00',
  'kyc.field.taxId.hint': 'SSN/EIN (US), CPF (BR) ou equivalente local.',
  'kyc.field.country.label': 'País de residência',
  'kyc.field.country.placeholder': 'Selecione um país',
  'kyc.field.phone.label': 'Telefone (opcional)',
  'kyc.field.phone.placeholder': '+1 555 123 4567',
  'kyc.field.addressLine1.label': 'Endereço linha 1',
  'kyc.field.addressLine1.placeholder': 'Rua e número',
  'kyc.field.addressLine2.label': 'Endereço linha 2 (opcional)',
  'kyc.field.addressLine2.placeholder': 'Apto, sala, unidade',
  'kyc.field.city.label': 'Cidade',
  'kyc.field.stateProvinceRegion.label': 'Estado / Província / Região',
  'kyc.field.postalCode.label': 'CEP / código postal',
  'kyc.field.idDocCountry.label': 'País emissor do documento',
  'kyc.field.idDocType.label': 'Tipo de documento',
  'kyc.field.idDocType.placeholder': 'Selecione um tipo de documento',
  'kyc.field.idDocType.passport': 'Passaporte',
  'kyc.field.idDocType.id_card': 'Documento nacional de identidade',
  'kyc.field.idDocType.drivers': 'Carteira de motorista',
  'kyc.field.idDocNumber.label': 'Número do documento (opcional)',
  'kyc.field.selfieFile.label': 'Selfie',
  'kyc.field.selfieFile.hint':
    'Tire uma foto nítida do seu rosto — sem óculos, sem chapéu, bem iluminada. JPG ou PNG, máx. 8 MB.',
  'kyc.field.idDocFrontFile.label': 'Documento — frente',
  'kyc.field.idDocFrontFile.hint':
    'Foto da frente do seu documento, com os quatro cantos visíveis. JPG ou PNG, máx. 8 MB.',
  'kyc.field.idDocBackFile.label': 'Documento — verso',
  'kyc.field.idDocBackFile.hint':
    'Obrigatório para documentos de identidade e carteiras de motorista. JPG ou PNG, máx. 8 MB.',
  'kyc.upload.cta': 'Escolher arquivo',
  'kyc.upload.replace': 'Substituir',
  'kyc.upload.uploading': 'Enviando...',
  'kyc.upload.uploaded': 'Enviado',
  'kyc.upload.error': 'Falha no envio. Tente outro arquivo.',
  'kyc.upload.unsupported': 'Use JPG, PNG ou WebP com menos de 8 MB.',
  'kyc.upload.preview': 'Pré-visualização',
  'kyc.error.required': 'Este campo é obrigatório.',
  'kyc.error.email': 'Informe um endereço de e-mail válido.',
  'kyc.error.country': 'Use o código ISO-3166-1 alfa-2 (ex.: US, BR, FR).',
  'kyc.error.dateOfBirth': 'Informe uma data de nascimento válida.',
  'kyc.error.minor': 'Você deve ter 18 anos ou mais.',
  'kyc.error.generic':
    'Não foi possível iniciar sua verificação de identidade. Tente novamente em instantes.',
  'kyc.review.heading': 'Verificação de identidade enviada',
  'kyc.review.body':
    'Sua verificação de identidade está em análise. Enviaremos um e-mail quando ela for processada.',
  'kyc.review.cta': 'Ver status do pagamento',
  'kyc.review.summary.heading': 'Revise suas informações',
  'kyc.review.summary.body':
    'Reserve um momento para confirmar se está tudo certo. Após o envio, você não pode editar um envio de KYC — seria necessário iniciar um novo.',
  'kyc.submit': 'Enviar verificação de identidade',
  'kyc.submit.pending': 'Enviando...',
  'kyc.next': 'Continuar',
  'kyc.back': 'Voltar',
  'kyc.status.label': 'Status',
  'kyc.status.verifying': 'Em análise',
  'kyc.status.approved': 'Aprovado',
  'kyc.status.rejected': 'Rejeitado',
  'kyc.status.notStarted': 'Não iniciado',
  'kyc.hosted.cta': 'Continuar para o provedor de identidade',
  'onramp.heading': 'Escolha como você quer pagar',
  'onramp.subheading':
    'Travamos uma cotação de câmbio por 10 minutos assim que você seleciona uma forma de pagamento.',
  'onramp.method.ach': 'ACH (transferência bancária dos EUA)',
  'onramp.method.wire': 'Transferência via wire',
  'onramp.method.sepa': 'SEPA (transferência bancária da UE)',
  'onramp.method.card': 'Cartão',
  'onramp.method.label': 'Forma de pagamento',
  'onramp.targetCurrency.label': 'Moeda que você vai enviar',
  'onramp.targetCurrency.helper':
    'Convertemos pela taxa travada quando os fundos chegam. Faça a correspondência com a conta de onde você está enviando.',
  'onramp.quote.locked': 'Cotação travada. Expira em {expires}.',
  'onramp.quote.expired': 'A cotação expirou. Atualize para travar uma nova.',
  'onramp.quote.refresh': 'Atualizar cotação',
  'onramp.cta.lockQuote': 'Travar cotação de câmbio',
  'onramp.cta.confirm': 'Confirmar e obter as instruções',
  'onramp.cta.confirm.pending': 'Enviando...',
  'onramp.error.generic':
    'Não foi possível iniciar o on-ramp (entrada de fundos). Tente novamente em instantes.',
  'onramp.instructions.heading': 'Envie seu pagamento',
  'onramp.instructions.subheading':
    'Esta conta é exclusiva da sua fatura — envie o valor exato e nós associamos sua transferência automaticamente.',
  'onramp.instructions.bank': 'Banco',
  'onramp.instructions.accountName': 'Nome da conta',
  'onramp.instructions.accountNumber': 'Número da conta',
  'onramp.instructions.routing': 'Routing number',
  'onramp.instructions.iban': 'IBAN',
  'onramp.instructions.swift': 'SWIFT / BIC',
  'onramp.instructions.reference': 'Código de referência',
  'onramp.instructions.memo': 'Memo',
  'onramp.instructions.copy': 'Copiar',
  'onramp.instructions.copied': 'Copiado',
  'onramp.instructions.continue': 'Acompanhar este pagamento',
  'onramp.instructions.empty':
    'Nenhuma instrução bancária retornada ainda. Enviaremos por e-mail quando estiver pronta.',
  'tracking.heading': 'Acompanhamento do pagamento',
  'tracking.placeholder':
    'As telas de KYC, forma de pagamento e on-ramp (entrada de fundos) virão em PRs posteriores.',
  'tracking.cta.back': 'Voltar para a fatura',
  'tracking.cta.startOnRamp': 'Continuar para pagar',
  'tracking.refreshing': 'Verificando atualizações...',
  'tracking.timeline.heading': 'Progresso',
  'tracking.step.invoice': 'Fatura recebida',
  'tracking.step.kyc': 'Verificação de identidade concluída',
  'tracking.step.onramp': 'On-ramp (entrada de fundos) iniciado',
  'tracking.step.fiat': 'Fundos recebidos',
  'tracking.step.offramp': 'Off-ramp (saída de fundos) iniciado',
  'tracking.step.settled': 'Liquidado em BRL',
  'tracking.alert.kycRejected.heading': 'Verificação de identidade rejeitada',
  'tracking.alert.kycRejected.body':
    'Sua verificação de identidade não pôde ser aprovada. Reenvie com os dados atualizados.',
  'tracking.alert.kycRejected.cta': 'Reenviar verificação de identidade',
  'tracking.alert.kycPending.heading': 'Verificação de identidade em análise',
  'tracking.alert.kycPending.body':
    'Estamos aguardando o provedor de verificação. Enviaremos um e-mail quando for concluída.',
  'tracking.alert.underpayment.heading': 'Pagamento a menor detectado',
  'tracking.alert.underpayment.body':
    'O valor que recebemos é menor que o da fatura. Fale com o suporte para regularizar.',
  'tracking.alert.contactSupport': 'Falar com o suporte',
  'tracking.alert.expired.heading': 'Fatura expirada',
  'tracking.alert.expired.body': 'Esta fatura expirou. Peça ao vendedor para emitir uma nova.',
  'tracking.alert.cancelled.heading': 'Fatura cancelada',
  'tracking.alert.cancelled.body': 'O vendedor cancelou esta fatura.',
  'common.loading': 'Carregando...',
  'common.retry': 'Tentar novamente',
};
export default ptBR;
